export default __webpack_public_path__ + "static/media/red-card.efa58f5f.svg";